export default "__VITE_ASSET__D6nUHv$e__"